export default __webpack_public_path__ + "static/hero-winery-aafe5a20291ac9cef3fc7067763cbc95.jpg";